import axios from 'axios';
import { useMemo } from 'react';
import { useQuery } from 'react-query';

const apiUrl = () => process.env.REACT_APP_BASIX_API || '';

// item 997 (Chad) — internal awareness of what's shared to the customer portal: which
// customers have an active Customer Builder login and which capabilities it carries.
// Grids/forms badge rows the customer can actually see ("SHARED TO PORTAL").
export interface PortalShareCaps {
  customerId: string;
  proposals: boolean;
  invoices: boolean;
  contracts: boolean;
}

const usePortalShares = (): { capsFor: (customerId?: string | null) => PortalShareCaps | undefined } => {
  const { data } = useQuery<{ index: PortalShareCaps[] }>(
    'portalShares',
    async () => (await axios.get(`${apiUrl()}User/portal-shares`)).data,
    { staleTime: 5 * 60 * 1000 },
  );
  const map = useMemo(() => {
    const m = new Map<string, PortalShareCaps>();
    (data?.index ?? []).forEach((r) => m.set(String(r.customerId).toLowerCase(), r));
    return m;
  }, [data]);
  return {
    capsFor: (customerId?: string | null) => (customerId ? map.get(customerId.toLowerCase()) : undefined),
  };
};

export default usePortalShares;
